import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { CookieManagementService } from 'src/app/account/services/cookie-management.service';
import { TransactionRequestEtisalatInputParamsModel, TransactionRequestEtisalatPaymentModel } from '../../models/transaction-request-models';
import { TransactionResultReqParamsModel } from '../../models/transaction-result-models';
import { es3dgateService } from '../../services/3dsgate/3dsRequest.service';
import { TranscationRequestService } from '../../services/transaction-request/transcation-request.service';

@Component({
  selector: 'app-etisalat',
  templateUrl: './etisalat.component.html',
  styleUrls: ['./etisalat.component.scss']
})
export class EtisalatComponent implements OnInit {
  @Input() etisalatRequiredParams!:TransactionRequestEtisalatInputParamsModel;
  @Output() onError = new EventEmitter();

  public etisalatPaymentPage!:any;

  private subscriptions = new Subscription();

  constructor(
    private transactionRequestService:TranscationRequestService,
    private es3dgateService: es3dgateService,
    private sanitizer: DomSanitizer,
    private cookieManagementService: CookieManagementService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(
      this.transactionRequestService
      .TransactionRequest<
        TransactionRequestEtisalatInputParamsModel, 
        TransactionRequestEtisalatPaymentModel
      >('etisalat', this.etisalatRequiredParams)
      .pipe(
        concatMap(paymentInfo => {
          const paymentUrl = paymentInfo.paymentUrl;

          const amount = this.etisalatRequiredParams.amount;
          const transactionCompleteReqParams:TransactionResultReqParamsModel = {
            transactionId: paymentInfo.transactionId,
            orderId: paymentInfo.orderId,
            refCode: paymentInfo.refCode
          };

          localStorage.setItem('tCompleteParams', JSON.stringify(transactionCompleteReqParams))
          localStorage.setItem('amount', JSON.stringify(amount))

          return this.http.get(paymentUrl, {
            headers:{Accept: 'text/html'},
            responseType: 'text'
          });
        })
      )
      .subscribe(
        response => {
          this.etisalatPaymentPage = this.sanitizer.bypassSecurityTrustHtml(response);
        },
        err =>{
          this.onError.emit();
        }      
      )
    );
  }

}
